var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosssection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "73.041,438.961 73.041,0 27.32,0 27.32,39.266 27.32,447.052 27.32,484.406 27.32,484.516  27.32,484.516 27.32,484.678 27.32,484.678 64.95,484.678 64.95,484.678 511.998,484.678 511.998,438.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.084,484.734 452.08,484.734 452.08,484.734 451.918,484.734 451.922,511.751 451.918,511.834  451.922,511.834 451.922,511.996 472.732,512 472.732,484.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.552,484.678 81.556,511.7 81.552,511.778 81.556,511.778 81.556,511.941 102.367,511.945  102.367,484.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.008,484.698 205.012,511.715 205.008,511.794 205.012,511.794 205.012,511.961 225.822,511.961  225.822,484.702  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.628,484.714 328.624,484.714 328.624,484.714 328.463,484.714 328.467,511.735 328.463,511.814  328.467,511.814 328.467,511.976 349.277,511.98 349.277,484.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.002,430.446 27.264,430.446 27.268,409.632 0.006,409.635  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.057,60.084 27.075,60.08 27.154,60.08 27.154,60.08 27.316,60.08 27.32,39.266 0.061,39.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.037,183.539 27.3,183.535 27.304,162.721 0.041,162.725  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.022,306.994 27.04,306.99 27.118,306.99 27.118,306.99 27.28,306.99 27.284,286.176 0.022,286.18  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.829,290.072c19.854,0,36.006-16.152,36.006-36.002c0-4.606-0.85-9.024-2.529-13.181l56.362-48.503 c5.425,3.106,11.53,4.734,17.827,4.734c5.642,0,11.186-1.335,16.204-3.888l58.092,54.319c-1.983,4.497-3.018,9.412-3.018,14.382 c0,19.85,16.152,36.002,36.002,36.002c19.85,0,36.002-16.152,36.002-36.002c0-6.117-1.514-12.027-4.406-17.274l60.526-66.52 c4.638,2.181,9.775,3.318,15.034,3.318c19.886,0,36.066-16.152,36.066-36.002c0-19.89-16.18-36.066-36.066-36.066 c-19.85,0-36.002,16.175-36.002,36.066c0,5.618,1.299,11.102,3.785,16.041l-61.08,67.216c-4.382-1.849-9.032-2.782-13.86-2.782 c-5.875,0-11.624,1.43-16.808,4.172l-57.718-54.011c2.174-4.741,3.311-9.886,3.311-15.038c0-19.85-16.179-36.002-36.066-36.002 c-19.854,0-36.006,16.152-36.006,36.002c0,4.71,0.861,9.174,2.568,13.323l-56.275,48.424c-5.476-3.145-11.624-4.796-17.954-4.796 c-19.886,0-36.066,16.175-36.066,36.065C117.764,273.92,133.944,290.072,153.829,290.072z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosssection);
export default __webpack_public_path__ + "static/media/crosssection.42c387ce.svg";
export { ForwardRef as ReactComponent };